import React from "react";
import { useStatsigContext } from "../elements-statsig-provider/utils";

export const InboxPhishingBanner = () => {
  const { featureGates } = useStatsigContext();

  if (!featureGates.inbox_phishing_banner?.()) {
    return null;
  }

  return (
    <div
      className="col-xs-12 bg-warning"
      style={{ marginTop: "30px", padding: "20px" }}
    >
      <p>
        <b>Security Alert: Increased Phishing Activity.</b>
      </p>
      <p>
        We’ve detected a recent surge in phishing attempts. Please remain
        vigilant before clicking any links in messages. Peerspace will never ask
        for your password or full banking information through a link in
        messaging.
      </p>
    </div>
  );
};
